import { createContext, type ReactNode, useContext, useMemo } from "react";

interface PaymentRedirectConfig {
  readonly redirectUrl?: string;
  readonly signature?: string;
}

const PaymentRedirectContext = createContext<PaymentRedirectConfig>({});

interface PaymentRedirectProviderProps extends PaymentRedirectConfig {
  readonly children: ReactNode;
}

export function PaymentRedirectProvider({ redirectUrl, signature, children }: PaymentRedirectProviderProps) {
  const value = useMemo(() => ({ redirectUrl, signature }), [redirectUrl, signature]);
  return <PaymentRedirectContext.Provider value={value}>{children}</PaymentRedirectContext.Provider>;
}

export function usePaymentRedirect(): PaymentRedirectConfig {
  return useContext(PaymentRedirectContext);
}
